import { SiteAtmosphere } from "./SiteAtmosphere";

type Props = {
  /** 0–1 progress for the loading bar. */
  progress?: number;
};

export function BootSplash({ progress = 0 }: Props) {
  const pct = Math.min(100, Math.max(0, Math.round(progress * 100)));

  return (
    <div className="boot-splash" role="status" aria-live="polite" aria-busy="true">
      <SiteAtmosphere />
      <div className="boot-splash-inner">
        <img
          src="/assets/logo.png"
          alt="Together In Heaven"
          className="boot-splash-logo"
        />
        <div className="boot-splash-progress" aria-hidden="true">
          <div
            className="boot-splash-progress-fill"
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className="boot-splash-label">Loading</span>
      </div>
    </div>
  );
}
